import { SubTopicObject, topics } from "assets/data/topics";
import { Button } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type SignupForm4Props = CustomComponentProps & {
    selectedTopics: SubTopicObject[];
    toggleTopic: Function;
    step: number;
    changeStep: React.Dispatch<React.SetStateAction<number>>;
    handleOpenModal: Function;
};

const SignupForm4 = ({
    selectedTopics,
    toggleTopic,
    handleOpenModal,
    step,
    changeStep,
    className,
    style
}: SignupForm4Props) => {
    return (
        <div
            id="signup-panel-4"
            className={`process-panel-wrap is-narrow ${className} ${step == 3 ? "is-active" : ""}`}
            style={style}
        >
            <p className="momeento-p text-center mb-20">
                You can select Topics to explore your posts and incidents to all
                users who’s interesting Topics you selected.
            </p>
            <div className="form-panel">
                <div
                    className={`fieldd mb-30 ${selectedTopics.length ? "" : "is-hidden"}`}
                    id="choosen-topics-field"
                >
                    <div className="topic-head d-flex flex-j-between gap-10 pt-10 pb-15">
                        <h2>Choosen Topics</h2>
                        <div className="tooltip">
                            <div className="momeento-svg info-svg svg-18"></div>
                            <span className="tooltiptext momeento-p">
                                You can select up to four topics to explore your
                                posts and incidents to all users who's
                                intersting topics you selected.
                            </span>
                        </div>
                    </div>
                    <ul
                        className="ks-cboxtags topic-body d-flex flex-wrap flex-j-start gap-5"
                        id="choosen-topics-ul"
                    >
                        {selectedTopics.map((topic) => (
                            <li
                                key={topic.SubTopicId}
                                className="checked"
                                onClick={() => toggleTopic(topic)}
                            >
                                <label>{topic.Name}</label>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="topics-form-panel" id="topics-form-panel">
                    {topics.map((t) => (
                        <div className="field" key={t.TopicId}>
                            <div className="topic-head d-flex flex-j-between gap-10 pt-10">
                                <h2>{t.Name}</h2>
                                {t.SubTopics.length > 6 ? (
                                    <a
                                        className="button modal-trigger"
                                        onClick={() =>
                                            handleOpenModal(t.Name, t.SubTopics)
                                        }
                                    >
                                        View More
                                    </a>
                                ) : (
                                    ""
                                )}
                            </div>
                            <ul className="ks-cboxtags topic-body d-flex flex-wrap flex-j-start gap-5">
                                {t.SubTopics.slice(0, 6).map((topic) => (
                                    <li
                                        key={topic.SubTopicId}
                                        onClick={() => toggleTopic(topic)}
                                        className={
                                            selectedTopics.includes(topic)
                                                ? "checked"
                                                : ""
                                        }
                                    >
                                        <label>{topic.Name}</label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            <div className="buttons">
                <Button
                    text="Back"
                    handleClick={() => changeStep(step - 1)}
                    color=""
                />
                <Button text="Next" handleClick={() => changeStep(step + 1)} />
            </div>
        </div>
    );
};

export default SignupForm4;
